export default __webpack_public_path__ + "static/media/Spy_Glass.f72d4f14.mp3";